import { ReactNode } from 'react';
import { default as SuccessIcon } from '@mui/icons-material/CheckCircle';
import { default as ErrorIcon } from '@mui/icons-material/Error';
import { default as WarningIcon } from '@mui/icons-material/Warning';
import { default as Box } from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { SxProps } from '@mui/system/styleFunctionSx';
import { StyledCard } from './styledComponents';

interface Props {
  children: ReactNode;
  sx?: SxProps;
  dataTestId?: string;
  small?: boolean;
  type?: 'warning' | 'error' | 'success';
}

export const WarningCard = ({
  children,
  sx,
  dataTestId = 'warning-card',
  small = false,
  type = 'warning'
}: Props) => {
  const theme = useTheme();

  const modifiedSx = small
    ? {
        p: theme.spacing(1.5, 1),
        borderRadius: '8px',
        '& svg': { marginRight: theme.spacing(1), width: '0.85em' },
        '& p': { fontSize: 12 }
      }
    : null;

  return (
    <StyledCard
      sx={{
        ...modifiedSx,
        backgroundColor: theme.palette[type].lighter,
        ...sx
      }}
      data-testid={dataTestId}
    >
      {type === 'error' && (
        <ErrorIcon sx={{ color: theme.palette[type].main }} />
      )}
      {type === 'warning' && (
        <WarningIcon sx={{ color: theme.palette[type].main }} />
      )}
      {type === 'success' && (
        <SuccessIcon sx={{ color: theme.palette[type].main }} />
      )}
      <Box
        sx={{
          '& p': {
            color: theme.palette[type].darker,
            fontWeight: 500,
            paddingTop: '2px'
          }
        }}
      >
        {children}
      </Box>
    </StyledCard>
  );
};
